import { AlphaRIcon } from './AlphaRIcon';

/**
 * author: GreenTurtwig
 * id A1C326AD-B2A8-4A9A-98AA-B657C101EB2F
 * name alpha-r
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-r.svg
 * tags
 * - Automotive 
 * - Alpha / Numeric 
 */
export const ReverseIcon = AlphaRIcon;
export default ReverseIcon